import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Circle, Rect, SVG } from '@wordpress/primitives';
export const PatreonIcon = () => createElement(SVG, {
  width: "24",
  height: "24",
  viewBox: "0 0 569 546",
  version: "1.1"
}, createElement(Circle, {
  cx: "363",
  cy: "205",
  r: "205"
}), createElement(Rect, {
  width: "100",
  height: "546",
  x: "0",
  y: "0"
}));
//# sourceMappingURL=patreon.js.map